(function () {
  function safePublish(eventName, payload) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(eventName, payload || {});
      }
    } catch (e) {}
  }

  function scanProductLists(root) {
    const scope = root || document;
    const lists = scope.querySelectorAll('[data-product-list]');
    if (!lists.length) return;

    lists.forEach(function (listEl) {
      if (listEl.dataset.productListTracked === 'true') {
        return;
      }

      const listName = listEl.getAttribute('data-product-list-name') || 'Product list';

      const defaultCurrency =
        listEl.getAttribute('data-product-list-currency') ||
        (window.Shopify && Shopify.currency && Shopify.currency.active) ||
        (window.Shopify && Shopify.shop && Shopify.shop.currency) ||
        undefined;

      const itemEls = listEl.querySelectorAll('[data-product-item]');
      if (!itemEls.length) return;

      const products = [];

      itemEls.forEach(function (itemEl) {
        const productId = itemEl.getAttribute('data-product-id');
        const sku = itemEl.getAttribute('data-product-sku');
        const title = itemEl.getAttribute('data-product-title');
        const vendor = itemEl.getAttribute('data-product-vendor');
        const priceRaw = itemEl.getAttribute('data-product-price');
        const currencyCode = itemEl.getAttribute('data-product-currency') || defaultCurrency;

        const availabilityAttr = itemEl.getAttribute('data-product-availability');
        const categoryAttr = itemEl.getAttribute('data-product-category') || null;
        // Kategoria zgodna z feedem produktowym (metapole custom.google_product_type).
        // Pelna sciezka z separatorem ">", np. "Dom i ogrod > Nozyce ogrodowe" —
        // rozbicie na poziomy GA4 robi custom pixel.
        const googleCategoryAttr = itemEl.getAttribute('data-product-google-category') || null;

        const priceNum = priceRaw ? Number(String(priceRaw).replace(',', '.')) : undefined;

        if (!productId && !sku) {
          return;
        }

        products.push({
          product: {
            id: productId,
            title,
            vendor,
            category: categoryAttr,
            googleCategory: googleCategoryAttr,
          },
          sku,
          price: {
            amount: priceNum,
            currencyCode,
          },
          availability: availabilityAttr,
        });
      });

      if (!products.length) return;

      safePublish('product_list_viewed', {
        listName,
        products,
      });

      listEl.dataset.productListTracked = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {
      const link = e.target.closest && e.target.closest('a[href^="tel:"]');
      if (!link) return;

      const href = link.getAttribute('href') || '';
      const phone = href.replace(/^tel:/i, '').replace(/\s+/g, '').trim();
      const phonePlacement = link.getAttribute('data-phone-location') || 'body';

      safePublish('phone_clicked', {
        phone,
        phonePlacement,
      });
    });

    const newsletterForms = document.querySelectorAll('form.newsletter-form');

    newsletterForms.forEach(function (form) {
      form.addEventListener('submit', function () {
        try {
          const emailInput =
            form.querySelector('input[type="email"]') ||
            form.querySelector('input[name="email"]') ||
            form.querySelector('input');

          const email = emailInput && emailInput.value ? emailInput.value.trim() : '';

          safePublish('newsletter_subscribed', {
            subscribeEmail: email,
          });
        } catch (err) {}
      });
    });

    scanProductLists();

    const observer = new MutationObserver(function (mutations) {
      let shouldRescan = false;

      mutations.forEach(function (mutation) {
        const added = Array.from(mutation.addedNodes || []);
        added.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;

          if (
            (node.matches && (node.matches('[data-product-list]') || node.matches('[data-product-item]'))) ||
            (node.querySelector &&
              (node.querySelector('[data-product-list]') ||
                node.querySelector('[data-product-item]')))
          ) {
            shouldRescan = true;
          }
        });
      });

      if (shouldRescan) {
        scanProductLists();
      }
    });

    try {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    } catch (e) {}

    document.addEventListener('shopify:section:load', function (e) {
      scanProductLists(e.target || document);
    });
  });
})();
